import React, { useEffect, useState } from 'react'
import { getGoodTypesAllAPI } from '../../../api/products/goodTypeAPI'
import MySelect from '../../UI/form/MySelect'
import { responseError } from '../../../helpers/response/ResponseHelper'

const GoodTypeSelectMain = ({ required, setValidate, setValueForm, forciblyValue }) => {

  	const [value, setValue] = useState(forciblyValue)
	const [goodTypes, setGoodTypes] = useState([])

	useEffect(() => {
		getGoodTypes()
	}, [])

	useEffect(() => {
		valid()
	}, [required, value])

	const getGoodTypes = () => {
		getGoodTypesAllAPI().then(data => {
			setGoodTypes(data)
		}).catch(e => {
			// setError(responseError(e))
			console.error(responseError(e))
		})
	}

	const valid = () => {
		if (required) {
			if (value) {
				setValidate(true)
			} else {
				setValidate(false)
			}
		} else {
			setValidate(true)
		}
	}

  return (
    <MySelect
        value={value}
        label="Тип товару"
        labelId="select__goodType-label"
        id='select__goodType'
        onChange = {e => {
			setValueForm(e)
            setValue(e)
			// setEvent({...event, categoryId: e})
		}}
        nameField='Тип товару'
        // sx={{width: '200px'}}
        options={
			goodTypes && goodTypes.length > 0 ? 
				goodTypes.map(goodType => {
            		return {id: goodType.id, name: goodType.name}
				})
			: []	
		}
        // options={[]}
    />
  )
}

export default GoodTypeSelectMain